import { PeerReviewStatus } from '../types/peerReview.type'
import { Attribute } from './attributes.model'
import { FileMeta } from './file-meta.model'
import { ReviewItem } from './reviewItem.model'
import { ArticleMetadata } from './reviewItemMetadata/articleMetadata'
import { Search } from './search.model'
import { ReviewItemType } from '../types/reviewItemType.type'

export class Article extends ReviewItem {
  metadata: ArticleMetadata
  constructor({
    complaintDate,
    search,
    appraisal,
    fullTextScreening,
    suggestedFullTextScreening,
    id,
    isFavorite,
    maybeParentStudyId,
    oxfordLevelOfEvidence,
    parentStudyId,
    pdfFile,
    peerReviewStatus,
    synthesis,
    titleAndAbstractScreening,
    metadata,
  }: {
    complaintDate?: Date
    search: Search
    appraisal?: { [key: string]: string }
    fullTextScreening?: string
    suggestedFullTextScreening?: string
    id: number
    isFavorite?: boolean
    maybeParentStudyId?: number
    oxfordLevelOfEvidence?: string
    parentStudyId?: number
    pdfFile?: FileMeta
    peerReviewStatus?: PeerReviewStatus
    synthesis?: { attributes: Attribute[] }
    titleAndAbstractScreening?: string
    metadata?: ArticleMetadata
  }) {
    super({
      complaintDate,
      search,
      appraisal,
      fullTextScreening,
      suggestedFullTextScreening,
      id,
      isFavorite,
      maybeParentStudyId,
      oxfordLevelOfEvidence,
      parentStudyId,
      pdfFile,
      peerReviewStatus,
      synthesis,
      titleAndAbstractScreening,
    })
    this.metadata = new ArticleMetadata(metadata ?? {})
    this.type = ReviewItemType.Article
  }

  get DoiLink() {
    return this.metadata.doi ? `https://doi.org/${this.metadata.doi}` : ''
  }
}
